var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBedFront(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 160C80 142.375 94.375 128 112 128H208C225.625 128 240 142.375 240 160V192H272V160C272 142.375 286.375 128 304 128H400C417.625 128 432 142.375 432 160V192H480V64C480 46.375 465.625 32 448 32H64C46.375 32 32 46.375 32 64V192H80V160ZM448 224H64C28.625 224 0 252.625 0 288V464C0 472.875 7.125 480 16 480H48C56.875 480 64 472.875 64 464V416H448V464C448 472.875 455.125 480 464 480H496C504.875 480 512 472.875 512 464V288C512 252.625 483.375 224 448 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedFront);
export default __webpack_public_path__ + "static/media/bed-front.fe2c6ed120677ffcd6c60ba2d067cc74.svg";
export { ForwardRef as ReactComponent };